import { Badge, Col, Row, Tabs } from "antd"
import React from "react"
import PageHeader from "../../../components/Elements/PageHeader"
import { ShoppingCartOutlined } from "@ant-design/icons"
import ActiveOrders from "./ActiveOrders"
import MachineDoneList from "../../../components/Orders/Machines/MachineDoneList"
import WaitingList from "../../../components/Machines/WaitingList/WaitingList"
import TicketHoldOrders from "../../../components/Tickets/TicketHoldOrders"
import useFetchTicketsHoldOrders from "../../../store/Tickets/useFetchTicketHoldOrders"

export default function ArsomaOrders() {
  const { ticketsHoldOrderCount, loading: holdOrdersLoading } = useFetchTicketsHoldOrders()
  const onChange = (key) => {
    console.log(key)
  }
  const items = [
    {
      key: "1",
      label: `Active Orders`,
      children: <ActiveOrders />,
    },
    {
      key: "2",
      label: `Waiting List (paper manager)`,
      children: <WaitingList forMachine="Arsoma" />,
    },
    {
      key: "3",
      label: `Done List`,
      children: <MachineDoneList doneForMachine="Arsoma" />,
    },
    {
      key: "4",
      label: (
        <Badge
          count={holdOrdersLoading ? 0 : ticketsHoldOrderCount}
          size="large"
          offset={[10, 0]}
          overflowCount={999}>
          Orders on Hold
        </Badge>
      ),
      children: <TicketHoldOrders forManager={true} />,
    },
  ]

  return (
    <div style={{ padding: 15 }}>
      <Row>
        <Col span={24}>
          <PageHeader text="Arsoma Orders" icon={<ShoppingCartOutlined />} />
        </Col>
        <Col span={24}>
          <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
        </Col>
      </Row>
    </div>
  )
}
